import styled from 'styled-components';

import { getColor, getSpace, mq } from '@stylesheets/tools';

import { getGradientOutline } from '../../wishes.style';

const StyledWish = styled.div`
  .wish__trigger {
    position: absolute;
    top: calc(50% - 150px);
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    overflow: hidden;
    ${props => props.$wishColor && `filter: drop-shadow(0 0 14px ${props.$wishColor});`}

    width: 112px;
    height: 112px;

    ${mq('m')} {
      width: 142px;
      height: 142px;
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  .wish__header,
  .wish__content {
    color: ${getColor('black')};
  }

  .wish__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
      text-transform: none;

      ${mq('m')} {
        font-size: 22px;
      }
    }
  }

  .wish__icon {
    position: absolute !important;
    top: -12px;
    left: -12px;
    ${getGradientOutline()};
    color: ${getColor('black')};

    &:before {
      border-radius: 50%;
    }

    &-inner {
      position: relative;
      background: ${getColor('white')};
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 18px;
      }
    }
  }

  [role='dialog'] {
    outline: none;
  }

  .wish__panel {
    border: 2px solid ${getColor('darkGray')};
    background-color: ${getColor('white')};
    box-shadow: 0 2px 4px rgba(0, 10, 20, 0.1);
    border-radius: 10px;
    box-sizing: border-box;
    width: 260px;
    max-width: 260px;
  }

  .wish__wrapper {
    padding: ${getSpace('xs')} ${getSpace('xxs')} 25px;
  }

  .wish__content {
    display: flex;
    flex-wrap: wrap;
    gap: ${getSpace('xxxs')};
    margin-top: ${getSpace('xs')};
  }

  .wish__tag {
    position: relative;

    p {
      position: relative;
      background: ${getColor('white')};
      z-index: 1;
      text-transform: uppercase;
      padding: 2px 4px;
    }

    &:before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(88.85deg, #606ded 6.29%, #72f2ed 25.26%, #fc4cea 40.31%);
      filter: blur(3px);
      opacity: 0.8;
    }
  }
`;

export default StyledWish;
